<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.9998 2V4.07466C8.50717 4.44334 6.99978 6.14816 6.99978 8.53709C6.99978 11.053 8.18203 11.9747 11.1133 12.7395L12.2535 13.0219L12.6917 13.1407C14.4902 13.6552 14.9998 14.1842 14.9998 15.5306C14.9998 16.9483 13.8978 18 11.9998 18C10.6424 18 9.64912 17.1385 8.93949 15.1886C8.75061 14.6696 8.17678 14.402 7.6578 14.5909C7.13881 14.7798 6.87121 15.3536 7.06008 15.8726C7.88625 18.1427 9.21588 19.5316 10.9998 19.9006V22C10.9998 22.5523 11.4475 23 11.9998 23C12.5521 23 12.9998 22.5523 12.9998 22V19.9239C15.4242 19.5436 16.9998 17.7783 16.9998 15.5306C16.9998 12.7992 15.6766 11.8158 12.5083 11.0236L11.6532 10.8142L11.2093 10.6953C9.46391 10.2036 8.99978 9.73547 8.99978 8.53709C8.99978 6.96005 10.0166 6 12.0504 6C13.3901 6 14.3666 6.87449 15.0547 8.86398C15.2353 9.38593 15.8047 9.66269 16.3267 9.48214C16.8486 9.3016 17.1254 8.73213 16.9448 8.21019C16.1372 5.87532 14.8065 4.45197 12.9998 4.09116V2C12.9998 1.44772 12.5521 1 11.9998 1C11.4475 1 10.9998 1.44772 10.9998 2Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'DollarIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
